export const YM_TRACKING_ID = '28632361'

// https://yandex.ru/support/metrica/objects/hit.html
export const pageview = url => {
  window.ym(YM_TRACKING_ID, 'hit', url)
}
